import { adminHttpClient } from '../../commons/adminHttpClient'
import { SummaryFees } from '../common/models'

export type PerksConfirmSubscriptionFeesRequest = {
  planCode: string
}

export const perksConfirmSubscriptionFeesApi = (request: PerksConfirmSubscriptionFeesRequest): Promise<SummaryFees> => {
  return adminHttpClient.post('/AdminSignup/Perks/Subscription/Fees', request)
}
